<template>
	<div class="form-popup-view">
		<div class="form">
			<div v-for="(input, i) in form" :key="i" class="input">
				<div class="label" v-show="input.label && input.type != 'text'">{{ input.label }}</div>
				<textarea :placeholder="input.label" v-if="input.type == 'text' && false" v-model="input.value" style="background: yellow;" />
				<text-view :placeholder="input.label" v-if="input.type == 'text'" v-model="input.value"  />
				<div class="value" v-if="input.type == 'date'" @click.stop.prevent="dateInputClick(input)">{{ input.value.getDate() }}. {{ months[input.value.getMonth()] }} {{ input.value.getFullYear() }}</div>
				<div class="value" v-if="input.type == 'select'" @click.stop.prevent="selectInputClick(input)">{{ selectOptionLabel(input) }}</div>
				<div class="value number" v-if="input.type == 'number'" @click.stop.prevent="">
					<div class="dec"><div class="button" @click.stop="stepInput(input, -1)">-</div></div>
					<div class="value"><input type="text" v-model="input.value" @input="linkInput(input)" /></div>
					<div class="inc"><div class="button" @click.stop="stepInput(input, 1)">+</div></div>
				</div>
				<div class="value number currency" v-if="input.type == 'currency'" @click.stop.prevent="">
					<div class="value" style="text-align: right; padding-right: 10px;"><input style="text-align: right; width: 100%;" type="text" v-model="input.value" /></div>
				</div>
				<div class="value switch" v-if="input.type == 'switch'" @click.stop="input.value = !input.value">
					<div class="value" style="text-align: right;"><switch-view style="display: inline-block;" v-model="input.value" /></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import DatePopupView from '@/components/DatePopupView'
	import SelectPopupView from '@/components/SelectPopupView'
	import SwitchView from '@/components/SwitchView'
	import TextView from '@/components/TextView'

	export default {
		name: 'form-popup-view',
		props: ['callback', 'form'],
		components: {
			SwitchView,
			TextView
		},
		data() {
			return {
				months: [
					'januar',
					'februar',
					'marts',
					'april',
					'maj',
					'juni',
					'juli',
					'august',
					'september',
					'oktober',
					'november',
					'december'
				]
			};
		},
		methods: {
			linkInput(input) {
				if (!input.link || !input.rate) return;
				var target = this.form.find(function (f) { return f.name === input.link; });
				if (target) target.value = Math.round((parseFloat(input.value) || 0) * input.rate * 100) / 100;
			},
			stepInput(input, d) {
				input.value = (parseFloat(input.value) || 0) + d;
				this.linkInput(input);
			},
			selectOptionLabel(input) {
				for (var i = 0; i < input.options.length; ++i) {
					if (input.options[i].value == input.value) {
						return input.options[i].label;
					}
				}

				return 'FEJL';
			},
			selectInputClick(input) {
				if (!input) return;

				var self = this;
				var options = [];

				for (var i = 0; i < input.options?.length || 0; ++i) {
					(function () {
						var value = input.options[i].value;

						options.push({
							label: input.options[i].label,
							callback() {
								console.log(value);
								input.value = value;
								self.$store.commit('popPopup');
							}
						});
					})();
				}

				this.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: 'Vælg type',
						options: options,
						callback(e) {
							input.value = e;
							self.$store.commit('popPopup');
						},
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			},
			dateInputClick(input) {
				var self = this;

				this.$store.commit('pushPopup', {
					component: DatePopupView,
					props: {
						title: 'Vælg dato',
						date: input.value,
						callback(e) {
							input.value = e;
							self.$store.commit('popPopup');
						},
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.form-popup-view {
		& > .form {
			display: grid;
			row-gap: 1px;
			background-color: rgb(236, 236, 236);

			& > .input {
				background-color: white;
				display: grid;
				grid-template-columns: 1fr 1fr;
				padding: 0 0 0 20px;

				& > textarea {
					width: 100%;
					border: none;
					grid-column: 1 / 3;
					padding: 20px 20px 20px 0;
					outline: none;
					height: 200px;
				}

				& > .value, & > .label {
					line-height: 48px;
					white-space: nowrap;
				}

				& > .value {
					text-align: right;
					padding-right: 20px;

					&.number {
						padding-right: 10px;
						display: grid;
						grid-template-columns: 32px 1fr 32px;

						& > .value {
							text-align: center;

							& > input {
								font-size: 16px;
								height: 32px;
								width: 60px;
								text-align: center;
								border: none;
							}
						}

						& > .dec, & > .inc {
							text-align: center;

							& > .button {
								font-size: 18px;
								font-weight: bold;
								border-radius: 50%;
								line-height: 32px;
								color: white;
								width: 32px;
								height: 32px;
								background-color: #f7223f;
								margin-top: 10px;
							}
						}

						&.currency {
							grid-template-columns: 1fr;
						}
					}
				}
			}
		}
	}
</style>